// src/componentsdash/Modulos/Configuracion/Modulosconfiguracion/WhatsappAyudaConfigReceta.js

import React, { useEffect, useState } from "react";
import whatsappIcon from "../../../../assets/WhatsApp.png";

const WhatsappAyudaConfigReceta = ({ mostrarPorConfigPrevia = false, guardadoExitoso = false }) => {
  const [mostrarPorTiempo, setMostrarPorTiempo] = useState(false);

  useEffect(() => {
    if (guardadoExitoso) return;

    const timer = setTimeout(() => {
      setMostrarPorTiempo(true);
    }, 5 * 60 * 1000);

    return () => clearTimeout(timer);
  }, [guardadoExitoso]);

  if (guardadoExitoso) return null;

  const mostrar = mostrarPorTiempo || mostrarPorConfigPrevia;

  if (!mostrar) return null;

  const mensaje = encodeURIComponent(
    "Hola, necesito ayuda configurando mi receta en Salvir. Les puedo enviar el estilo que quiero para que me apoyen a configurarla."
  );

  return (
    <a
      href={`https://wa.me/5215644811995?text=${mensaje}`}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        position: "fixed",
        right: "23px",
        bottom: "23px",
        zIndex: 9999,
        
        display: "flex",
        alignItems: "center",
        gap: "12px",
        width: "fit-content",
        maxWidth: "430px",
        padding: "12px 16px",
        borderRadius: "14px",
        background: "#f0fff7",
        border: "1px solid #e5e9e7",
        color: "#12372a",
        textDecoration: "none",
        boxShadow: "0 4px 16px rgba(0, 0, 0, 0.16)",
        fontFamily: "inherit",
      }}
    >
      <img
        src={whatsappIcon}
        alt="WhatsApp"
        style={{
          width: "30px",
          height: "30px",
          flexShrink: 0,
        }}
      />

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          lineHeight: "1.25",
        }}
      >
        <strong
          style={{
            fontSize: "14px",
            marginBottom: "2px",
          }}
        >
          ¿Necesitas ayuda configurando tu receta?
        </strong>

        <span
          style={{
            fontSize: "13px",
          }}
        >
          Da clic aquí, envíanos el estilo que quieres y nosotros te apoyamos.
        </span>
      </div>
    </a>
  );
};

export default WhatsappAyudaConfigReceta;